import {API_URL} from './api-base'

const apiURL = API_URL
const bearerToken = process.env.REACT_APP_BEARER_TOKEN

async function client(
  endpoint,
  {data, headers: customHeaders, ...customConfig} = {},
) {
  const config = {
    method: data ? 'POST' : 'GET',
    body: data ? JSON.stringify(data) : undefined,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': data ? 'application/json' : undefined,
      ...customHeaders,
      'app-type': 'keap-client',
    },
    ...customConfig,
    users: {user_roles: ['Admin'], rep_id: 'amit.ramashankarsingh@thryv.com'},
  }

  // console.log('headers', config.headers)

  return window.fetch(`${apiURL}/${endpoint}`, config).then(async response => {
    if (response.status === 401) {
      // TODO: logout()
      // refresh the page for them
      // window.location.assign(window.location)
      return Promise.reject({message: 'Please re-authenticate.'})
    }

    if (response.status === 404) {
      const errObjectString = await response.text()
      if (errObjectString === 'Not Found') {
        return Promise.reject({message: 'Not found', status: 404})
      }
      const errObject = JSON.parse(errObjectString)
      return Promise.reject({
        message: errObject?.message || 'Not found',
        status: 404,
      })
    }

    let ignoreInviteData
    try {
      ignoreInviteData = await response.clone().json()
    } catch {
      ignoreInviteData = await response.clone().text()
    }
    if (ignoreInviteData?.message === 'ignore invite error') {
      return
    }

    let data
    if (response.status === 201) {
      try {
        data = await response.json()
      } catch {
        data = undefined
      }
    }
    if (response.status !== 204 && response.status !== 201) {
      if (
        ['application/pdf', 'image/png'].includes(
          response.headers.get('Content-Type'),
        )
      ) {
        data = await response.blob()
      } else {
        try {
          data = await response.json()
        } catch {
          // FULSAS-12190: a gateway timeout or proxy error can return a
          // non-JSON (HTML) body instead of the expected JSON shape. Without
          // this, JSON parsing throws here and escapes as a raw SyntaxError
          // instead of a clean, catchable rejection.
          data = {message: 'Request failed', status: response.status}
        }
      }
    }
    if (response.ok) {
      // eslint-disable-next-line no-prototype-builtins
      if (data && data.hasOwnProperty('sfToken')) {
        sessionStorage.setItem('sfToken', JSON.stringify(data.sfToken))
        delete data.sfToken
      }
      return data
    } else {
      return Promise.reject(data)
    }
  })
}

export {client}
